import { AUTH_ENDPOINT } from "Constants";
import { baseApi } from "Services";
import {
  ApplyOidcConfigRequest,
  ApplyOidcConfigResponse,
  ApplySamlConfigRequest,
  ApplySamlConfigResponse,
  ConfigurationRequest,
  ConfigurationResponse,
  DisableSsoRequest,
  DisableSsoResponse,
  OidcConfigRequest,
  OidcConfigResponse,
  OidcGroupMappingsRequest,
  OidcGroupMappingsResponse,
  SamlConfigRequest,
  SamlConfigResponse,
  SamlGroupMappingsRequest,
  SamlGroupMappingsResponse,
  UpdateOidcConfigRequest,
  UpdateOidcConfigResponse,
  UpdateOidcGroupMappingsRequest,
  UpdateOidcGroupMappingsResponse,
  UpdateSamlConfigRequest,
  UpdateSamlConfigResponse,
  UpdateSamlGroupMappingsRequest,
  UpdateSamlGroupMappingsResponse,
} from "../types";

export const ssoApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    configuration: build.query<ConfigurationResponse, ConfigurationRequest>({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/configuration`,
        params: { org_id: queryArg.orgId },
      }),
      providesTags: ["Authentication", "SSO"],
    }),
    disableSso: build.mutation<DisableSsoResponse, DisableSsoRequest>({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/disable`,
        method: "POST",
        params: { org_id: queryArg.orgId },
      }),
      invalidatesTags: ["Authentication", "SSO"],
    }),
    oidcGroupMappings: build.query<
      OidcGroupMappingsResponse,
      OidcGroupMappingsRequest
    >({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/oidc/configuration/group-mappings`,
        params: { org_id: queryArg.orgId },
      }),
      providesTags: ["SSO"],
    }),
    updateOidcGroupMappings: build.mutation<
      UpdateOidcGroupMappingsResponse,
      UpdateOidcGroupMappingsRequest
    >({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/oidc/configuration/group-mappings`,
        method: "PUT",
        body: queryArg.body,
      }),
      invalidatesTags: ["SSO"],
    }),
    oidcConfig: build.query<OidcConfigResponse, OidcConfigRequest>({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/oidc/configuration/${queryArg.configId}`,
      }),
      providesTags: ["SSO"],
    }),
    updateOidcConfig: build.mutation<
      UpdateOidcConfigResponse,
      UpdateOidcConfigRequest
    >({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/oidc/configuration`,
        method: "POST",
        body: queryArg.oidcSsoConfiguration,
      }),
      invalidatesTags: ["SSO"],
    }),
    applyOidcConfig: build.mutation<
      ApplyOidcConfigResponse,
      ApplyOidcConfigRequest
    >({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/oidc/configuration/${queryArg.configId}/apply`,
        method: "POST",
        body: queryArg.oidcSsoLoginBody,
      }),
      invalidatesTags: ["SSO"],
    }),
    //SAML
    samlGroupMappings: build.query<
      SamlGroupMappingsResponse,
      SamlGroupMappingsRequest
    >({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/saml/configuration/group-mappings`,
        params: { org_id: queryArg.orgId },
      }),
      providesTags: ["SSO"],
    }),
    updateSamlGroupMappings: build.mutation<
      UpdateSamlGroupMappingsResponse,
      UpdateSamlGroupMappingsRequest
    >({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/saml/configuration/group-mappings`,
        method: "PUT",
        body: queryArg.body,
      }),
      invalidatesTags: ["SSO"],
    }),
    samlConfig: build.query<SamlConfigResponse, SamlConfigRequest>({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/saml/configuration/${queryArg.configId}`,
      }),
      providesTags: ["SSO"],
    }),
    updateSamlConfig: build.mutation<
      UpdateSamlConfigResponse,
      UpdateSamlConfigRequest
    >({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/saml/configuration`,
        method: "POST",
        body: queryArg.samlSsoConfiguration,
      }),
      invalidatesTags: ["SSO"],
    }),
    applySamlConfig: build.mutation<
      ApplySamlConfigResponse,
      ApplySamlConfigRequest
    >({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/saml/configuration/${queryArg.configId}/apply`,
        method: "POST",
      }),
      invalidatesTags: ["SSO"],
    }),
  }),
});

export const {
  useConfigurationQuery,
  useDisableSsoMutation,
  useUpdateOidcConfigMutation,
  useOidcGroupMappingsQuery,
  useUpdateOidcGroupMappingsMutation,
  useOidcConfigQuery,
  useApplyOidcConfigMutation,
  useUpdateSamlConfigMutation,
  useSamlConfigQuery,
  useApplySamlConfigMutation,
} = ssoApi;
